export const replaceUnderscores = (value: string): string => value.replace(/_/g, '');
